import { IPromise, IHttpService, IQService, IRequestShortcutConfig, IHttpResponse } from "angular";

import { IMoment, IGoalHistoryQueryParams } from "./models";
import { ICollection } from "../models";
import { EnvironmentService } from "@gtmhub/env";
import { UserService, IUsersIdMap } from "@gtmhub/users";

export class TimelineService {
  public static $inject = ["$http", "$q", "EnvironmentService", "UserService"];

  constructor(private $http: IHttpService, private $q: IQService, private env: EnvironmentService, private userService: UserService) {}

  public getGoalHistory(goalId: string, targets: string, queryParams: IGoalHistoryQueryParams): IPromise<ICollection<IMoment>> {
    const config: IRequestShortcutConfig = {
      params: queryParams,
    };

    let q = "?q=";
    if (targets) {
      q = q + " targets:" + targets;
    }

    const url = this.env.getMomentsEndpoint(`/goals/${goalId}/history${q}`);

    const deferred = this.$q.defer<ICollection<IMoment>>();
    this.$q.all([this.$http.get<ICollection<IMoment>>(url, config), this.userService.getUsersIdMap()]).then((promiseResults) => {
      // promise results holds the array of resolved promises passed the $q.all
      const momentsResponse = promiseResults[0] as IHttpResponse<ICollection<IMoment>>;
      const momentsCollection = momentsResponse.data as ICollection<IMoment>;
      const usersMap = promiseResults[1] as IUsersIdMap;

      if (momentsCollection.items !== null) {
        for (let i = 0; i < momentsCollection.items.length; i++) {
          const m = momentsCollection.items[i];

          if (m.target === "task") {
            m.content = JSON.parse(m.content);
          }
          momentsCollection.items[i].owner = usersMap[momentsCollection.items[i].ownerId];
        }
      }
      deferred.resolve(momentsCollection);
    });

    return deferred.promise;
  }
}
